<div class="evaluation-form">
  <div
    *ngIf="selectedAlarm?.status"
    class="flex justify-between items-stretch mb-2"
  >
    <div class="mt-2 flex-1">
      <span class="text-lg font-semibold text-color">
        {{
          isEditMode ? "Modification de l'évaluation" : "Évaluation de l'alarme"
        }}
      </span>
      <p class="text-sm text-gray-600 dark:text-gray-100 m-0">
        {{
          isEditMode
            ? "Modifiez l'évaluation technique de cette alarme"
            : "Effectuez l'évaluation technique de cette alarme"
        }}
      </p>
    </div>

    <div
      *ngIf="selectedAlarm?.status"
      class="flex flex-col justify-center items-end border-l border-gray-300 dark:border-gray-600 pl-5 ml-5 mb-3"
    >
      <h3 class="text-base font-normal text-color mb-1 text-right">
        Date de début de l'alarme
      </h3>
      <div class="text-lg font-semibold text-color text-right">
        {{
          selectedAlarm?.startDate
            ? (selectedAlarm?.startDate | date: "dd/MM/yyyy HH:mm:ss")
            : "N/A"
        }}
      </div>
    </div>
  </div>

  <div class="grid-form">
    <form [formGroup]="evaluationForm" (ngSubmit)="onSubmit()">
      <div class="column">
        <div
          class="flex items-center mt-2"
          *ngIf="shouldShowPotentialCauseField"
        >
          <label for="potentialCause" class="basis-[30%] flex-none mb-0"
            >Cause potentielle :</label
          >
          <div class="flex flex-col w-full">
            <p-select
              formControlName="potentialCause"
              [options]="causeOptions"
              placeholder="Sélectionnez une cause potentielle"
              class="w-full"
              [disabled]="isFormDisabled"
            ></p-select>
          </div>
        </div>

        <div
          class="flex items-center mt-2"
          *ngIf="shouldShowCorrectiveActionField"
        >
          <label for="correctiveAction" class="basis-[30%] flex-none mb-0"
            >Action corrective :</label
          >
          <div class="flex flex-col w-full">
            <p-select
              [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
              formControlName="correctiveAction"
              [options]="actionOptions"
              placeholder="Sélectionnez une action corrective"
              class="w-full"
              [disabled]="isFormDisabled"
            ></p-select>
            <small
              class="text-blue-600 dark:text-blue-400 text-xs mt-1"
              *ngIf="
                isProdManualStage && selectedAlarm?.evaluation?.isVigieUpdated
              "
            >
              ✅ Vigie a été mis à jour. L'alerte peut maintenant être fermée.
            </small>
            <small
              class="text-orange-600 dark:text-orange-400 text-xs mt-1"
              *ngIf="
                isProdManualStage &&
                selectedAlarm?.evaluation?.isSentToVigie &&
                !selectedAlarm?.evaluation?.isVigieUpdated
              "
            >
              ⚠️ Vigie a été notifié (enquête). Sélectionnez une cause et une
              action, puis cliquez &laquo; Mettre à jour Vigie &raquo; pour
              déclencher la création du bon de travail SAP.
            </small>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="flex items-center mt-2" *ngIf="shouldShowCommentsField">
          <label for="comments" class="basis-[30%] flex-none mb-0"
            >Commentaires :</label
          >
          <textarea
            [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
            id="comments"
            formControlName="comments"
            rows="5"
            pInputTextarea
            class="w-auto flex-1"
            [disabled]="isFormDisabled"
          ></textarea>
        </div>
      </div>

      <div class="new-comment flex gap-2">
        <button
          *ngIf="shouldShowSaveButton"
          type="submit"
          pButton
          class="send-btn"
          label="Sauvegarder"
          severity="contrast"
          [disabled]="evaluationForm.invalid"
        ></button>

        <button
          *ngIf="shouldShowSendToVigieButton"
          type="button"
          pButton
          label="Mettre &agrave; jour Vigie"
          icon="pi pi-send"
          severity="info"
          [disabled]="!canSendToVigie || isUpdatingVigie"
          [loading]="isUpdatingVigie"
          (click)="onSendToVigie()"
        ></button>

        <button
          *ngIf="shouldShowCloseEvaluationButton"
          type="button"
          pButton
          [label]="'Fermer l\'alerte'"
          icon="pi pi-check"
          severity="success"
          [disabled]="!canCloseEvaluation || isForcedDisabled"
          [loading]="isForcedDisabled"
          (click)="onCloseEvaluation()"
        ></button>
      </div>
    </form>
  </div>
</div>
